import { render, staticRenderFns } from "./SocialResponsibility.vue?vue&type=template&id=7669b926&"
import script from "./SocialResponsibility.vue?vue&type=script&lang=js&"
export * from "./SocialResponsibility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports